
<p-dialog #dialog [hidden]="!showAccountCompletion"
          id="account-completion"
          header="Account Completion"
          [visible]="true"
          (visibleChange)="logmeout()"
          modal="modal"
          baseZIndex="1"
          minHeight="600"
          Height="600"
          minWidth="1400"
          width="1400"
>

  <div>
    <div class="center" id="errorDiv">
      <iui-messages mode="alert" class="ms-auto me-auto"></iui-messages>
    </div>

    <!--form #accountForm="ngForm" (ngSubmit)="save(accountForm.valid)" id="accountCompletionDialog"-->
    <form #accountForm="ngForm" id="accountCompletionDialog">
      <p>Please fill in the following fields to complete the creation of your account.</p>
      <div class="ui-g">

        <div class="ui-g-1">
          <div class="mb-3">
            <label class="disabled form-label" for="accountId">Account ID</label>
            <input type="text" class="form-control" id="accountId" disabled [(ngModel)]="myAccount.accountId"
                   name="accountId" placeholder="Account ID"
                   #accountId="ngModel">
          </div>
        </div>

        <div class="ui-g-1">
          <div class="mb-3">
            <label class="disabled form-label" for="spid">SPID</label>
            <input type="text" class="form-control" id="spid" [(ngModel)]="myAccount.spid" name="spid"
                   placeholder="xxxx" #spid="ngModel">
          </div>
        </div>

        <div class="ui-g-3">
          <div class="mb-3">
            <label class="disabled form-label" for="companyName">Company Name</label>
            <input autocomplete='organization' type="text" class="form-control" id="companyName" disabled
                   [(ngModel)]="myAccount.companyName"
                   name="companyName" placeholder="Company Name" #companyName="ngModel">
          </div>
        </div>

        <div class="ui-g-3">
          <div class="mb-3">
            <label class="form-label" for="purchaseOrderNumber">Purchase Order Number</label>
            <input autocomplete='purchaseOrderNumber' type="text" class="form-control" id="purchaseOrderNumber" 
                   [(ngModel)]="myAccount.purchaseOrderNumber" name="purchaseOrderNumber"
                   #purchaseOrderNumber="ngModel">
          </div>
        </div>

      </div>

      <div>
        <strong>Account Contact Information</strong>
      </div>
      <div class="ui-g">

        <div class="ui-g-2">

          <div class="mb-3">
            <label class="required form-label" for="firstName">First Name</label>
            <input autocomplete='given-name' type="text" class="form-control" id="firstName" required
                   [(ngModel)]="myAccount.firstName"
                   name="firstName" #firstName="ngModel">
          </div>

          <div class="mb-3">
            <label class="required form-label" for="lastName">Last Name</label>
            <input autocomplete='family-name' type="text" class="form-control" id="lastName" required
                   [(ngModel)]="myAccount.lastName"
                   name="lastName" #lastName="ngModel">
          </div>
        </div>

        <div class="ui-g-2">

          <div class="mb-3">
            <label class="required form-label" for="email">Email Address</label>
            <input autocomplete='email' type="text" class="form-control" id="email" required emailvalidator
                    [(ngModel)]="myAccount.email"
                    name="email" placeholder="email@domain.com" #email="ngModel">
          </div>

          <div class="mb-3">
            <label class="form-label" for="phone">Telephone Number</label>
            <input autocomplete='tel-national' type="text" class="form-control" id="phone" minlength="7"
                   [(ngModel)]="myAccount.phone"
                   name="phone" #phone="ngModel">
          </div>

        </div>

        <div class="ui-g-2">
          
            <div class="mb-3">
              <label class="form-label" for="country">Country</label>
              <div class="input-group">
                <p-dropdown autocomplete='country-name' #country id="country" 
                            [filter]="true" [style]="{'width': '100%'}"
                            class="p-formcontrol" [(ngModel)]="myAccount.country" iuiCountry [region]="state"
                            placeholder="Select" [name]="'country'"></p-dropdown>
              </div>
            </div>

          <div class="mb-3">
            <label class="form-label" for="address1">Address 1</label>
            <input autocomplete='address-line1' type="text" class="form-control" id="address1"
                   [(ngModel)]="myAccount.address1" name="address1"
                   placeholder="street address" #address1="ngModel">
          </div>

        </div>

        <div class="ui-g-2">

          <div class="mb-3">
            <label class="form-label" for="address2">Address 2</label>
            <input autocomplete='address-line2' type="text" class="form-control" id="address2"
                   [(ngModel)]="myAccount.address2" name="address2"
                   placeholder="suite, floor, etc." #address2="ngModel">
          </div>

          <div class="mb-3">
            <label class="form-label" for="city">City</label>
            <input autocomplete='address-level2' type="text" class="form-control" id="city" [(ngModel)]="myAccount.city"
                   name="city"
                   #city="ngModel">
          </div>

        </div>

        <div class="ui-g-2">

          <div class="mb-3">
            <label class="form-label" for="state">State/ Province</label>
            <div class="input-group">
              <p-dropdown autocomplete='address-level1' [disabled]="!myAccount.country" [(ngModel)]="myAccount.state" 
                          [filter]="true" [inputId]="'state'"
                          placeholder="Select" [style]="{'width': '100%'}" #state class="p-formcontrol"
                          id="state" iuiRegion [country]='country' [name]="'state'"></p-dropdown>
            </div>
          </div>

          <div class="mb-3">
              <label class="form-label" for="zipCode">Postal/ ZIP Code</label>
              <input autocomplete='postal-code' type="text" class="form-control" id="zipCode"
                     [(ngModel)]="myAccount.zipCode" name="zipCode"
                     #zipCode="ngModel">
            </div>

        </div>

      </div>

      <div style= "margin-bottom: .5em;">
        <strong>Billing Contact Information</strong>
      </div>
      <div class="ui-g mb-3">
        <p-checkbox [(ngModel)]="sameAsAccount" name="sameAsAccount" binary="true" (onChange)="sameAsAccountInfo($event)"></p-checkbox><label for="sameAsAccount">Same as Account Contact Information</label>
      </div>
      <div class="ui-g">

        <div class="ui-g-2">

          <div class="mb-3">
            <label class="required form-label" for="billingFirstName">Billing First Name</label>
            <input autocomplete='given-name' type="text" class="form-control" id="billingFirstName" required
                   [(ngModel)]="myAccount.billingFirstName"
                   name="billingFirstName" #billingFirstName="ngModel">
          </div>

          <div class="mb-3">
            <label class="required form-label" for="billingLastName">Billing Last Name</label>
            <input autocomplete='family-name' type="text" class="form-control" id="billingLastName" required
                   [(ngModel)]="myAccount.billingLastName"
                   name="billingLastName" #billingLastName="ngModel">
          </div>

        </div>

        <div class="ui-g-2">

          <div class="mb-3">
            <label class="required form-label" for="billingEmail">Billing Email Address</label>
            <input autocomplete='email' type="text" class="form-control" id="billingEmail" required emailvalidator
                   [(ngModel)]="myAccount.billingEmail"
                   name="billingEmail" placeholder="email@domain.com" #billingEmail="ngModel">
          </div>

          <div class="mb-3">
            <label class="required form-label" for="billingPhone">Billing Telephone Number</label>
            <input autocomplete='tel-national' type="text" class="form-control" id="billingPhone" minlength="7"
                   required [(ngModel)]="myAccount.billingPhone"
                   name="billingPhone" #billingPhone="ngModel">
          </div>

        </div>

        <div class="ui-g-2">

          <div class="mb-3 required">
            <label class="required form-label" for="billingCountry">Billing Country</label>
            <div class="input-group">
              <p-dropdown [(ngModel)]="myAccount.billingCountry"  [filter]="true"
                          [inputId]="'billingCountry'" placeholder="Select"
                          [required]="true" [style]="{'width': '100%'}" #billingCountry autocomplete='country-name'
                          class="p-formcontrol"
                          id="billingCountry" iuiCountry [region]="billingState" [name]="'billingCountry'"></p-dropdown>
            </div>
          </div>

          <div class="mb-3">
            <label class="required form-label" for="billingAddress1">Billing Address 1</label>
            <input autocomplete='address-line1' type="text" class="form-control" id="billingAddress1" required
                   [(ngModel)]="myAccount.billingAddress1"
                   name="billingAddress1" placeholder="street address" #billingAddress1="ngModel">
          </div>

        </div>


        <div class="ui-g-2">

          <div class="mb-3">
            <label class="form-label" for="billingAddress2">Billing Address 2</label>
            <input autocomplete='address-line2' type="text" class="form-control" id="billingAddress2"
                   [(ngModel)]="myAccount.billingAddress2"
                   name="billingAddress2" placeholder="suite, floor, etc." #billingAddress2="ngModel">
          </div>

          <div class="mb-3">
            <label class="required form-label" for="billingCity">Billing City</label>
            <input autocomplete='address-level2' type="text" class="form-control" id="billingCity" required
                   [(ngModel)]="myAccount.billingCity"
                   name="billingCity" #billingCity="ngModel">
          </div>

        </div>

        <div class="ui-g-2">

          <div class="mb-3 required">
            <label class="required form-label" for="billingState">Billing State/Province</label>
            <div class="input-group">
              <p-dropdown [disabled]="!myAccount.billingCountry" [(ngModel)]="myAccount.billingState"  [filter]="true"
                          [inputId]="'billingState'" [name]="'billingState'"
                          placeholder="Select" [required]="true" [style]="{'width': '100%'}" #billingState
                          autocomplete='address-level1'
                          class="p-formcontrol" id="billingState" iuiRegion [country]='billingCountry'>
              </p-dropdown>
            </div>
          </div>

          <div class="mb-3">
            <label
              [ngClass]="{'required':(myAccount.billingCountry == 'United States' || myAccount.billingCountry == 'Canada')}"
              class="form-label" for="billingZipCode">Billing Postal/ ZIP Code</label>
            <input autocomplete='postal-code' type="text" class="form-control" id="billingZipCode"
                   [required]="myAccount.billingCountry == 'United States' || myAccount.billingCountry === 'Canada'"
                   [(ngModel)]="myAccount.billingZipCode" name="billingZipCode"
                   #billingZipCode="ngModel">
          </div>

        </div>
      </div>

      <div>
        <label class="required form-label">
          <strong>Monthly Fee Schedule</strong>
        </label>
      </div>
      <div class="ui-g">
        <div class="ui-g-8">
          <fee-schedule *ngIf="myAccount.accountType === ACCOUNT_TYPE_STANDARD" [(selectedTier)]="myAccount.tier"></fee-schedule>
          <custom-fee-schedule *ngIf="myAccount.accountType === ACCOUNT_TYPE_NON_STANDARD"
                               [customTier]="myAccount.custom"
                               [disabled]="true"
                               [tierConfirmRequired]="true"
                               (tierConfirmed)="tierConfirmed = true"
          ></custom-fee-schedule>
        </div>
      </div>

    </form>
  </div>

  <ng-template pTemplate="footer">
    <div class="ps-3 pt-2 pb-2">
      <button type="button" id="save-account" class="btn btn-default width-100px" (click)="saveMyAccount()"
        [class]="'width-100px btn ' + (isFormValid() ? 'btn-default' : 'btn-disabled')" [disabled]='!isFormValid()'>
        Save
        </button>
        <span style="margin-left: 3em;"></span>
    </div>

  </ng-template>
</p-dialog>

